import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState = {
    pisLoading: false,
    stopsale: [],
    stopsaleImage: {},
    totalStopSale: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    piscLoading: false,
    pcstatus: "",
    pcMessage: "",
    imagemessage: "",
    pdetails: {},
    pismloading: false,
    pmstatus: "",
    pmmessage: "",
    pSDetails: {},
    pdstatus: "",
    pidstatus: "",
    ssmessage: "",
    pidmessage: "",
    error: "",
    productId: "",
    productimageall: [],

};


const productSlice = createSlice({
    name: "productList",
    initialState,
    reducers: {
        getStopSalePending: (state) => {
            state.pisLoading = true;
        },
        getStopSaleSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.stopsale = payload;
            state.error = '';
        },
        getStopSaleFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },

        getStopSaleImagePending: (state) => {
            state.pisLoading = true;
        },
        getStopSaleImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.productimageall = payload;
            state.error = '';
        },
        getStopSaleImageFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },
        createStopSalePending: (state, action) => {
            state.piscLoading = true;
        },
        createStopSaleSuccess: (state, { payload }) => {
            state.piscLoading = false;
            state.pcstatus = "success";
            state.pcMessage = "Stop Sale Added Successfully";
            state.productId = payload;

        },
        createStopSaleFail: (state, { payload }) => {
            state.piscLoading = false;
            state.pcstatus = "fail";
            state.pcMessage = payload;
        },
        getSStopSalePending: (state) => {
            state.pisLoading = true;
        },
        getSStopSaleSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.pSDetails = payload;
            state.error = '';
        },
        getSStopSaleFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },


        getSStopSaleImagePending: (state) => {
            state.pisLoading = true;
        },
        getSStopSaleImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.stopsaleImage = payload;
            state.error = '';
        },
        getSStopSaleImageFail: (state, action) => {

            state.pisLoading = false;
            state.error = action;
            state.imagemessage = action;
        },
        modifyStopSalePending: (state, action) => {
            state.pismloading = true;
            state.pmstatus = "";
        },
        modifyStopSaleSuccess: (state, { payload }) => {
            state.pismloading = false;
            state.pmstatus = "success";

            state.pmmessage = "StopSale Successfully Updated";
        },
        modifyStopSaleFail: (state, { payload }) => {
            state.pismloading = false;
            state.pmstatus = "fail";
            state.pmmessage = payload;
        },


        modifyStopSaleImagePending: (state, action) => {
            state.pismloading = true;
            state.pmstatus = "";
        },
        modifyStopSaleImageSuccess: (state, { payload }) => {
            state.pismloading = false;
            state.pmstatus = "success";

            state.pmmessage = "StopSale Successfully Updated";
        },
        modifyStopSaleImageFail: (state, { payload }) => {
            state.pismloading = false;
            state.pmstatus = "fail";
            state.pmmessage = payload;
        },
        deleteStopSalePending: (state, action) => {
            state.pisLoading = true;
            state.pdstatus = "";
        },
        deleteStopSaleSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.pdstatus = "success";
            state.ssmessage = "StopSale Successfully Deleted";
        },
        deleteStopSaleFail: (state, { payload }) => {
            state.pisLoading = false;
            state.pdstatus = "fail";
            state.ssmessage = payload;
        },

        deleteStopSaleImagePending: (state, action) => {
            state.pisLoading = true;
            state.pidstatus = "";
        },
        deleteStopSaleImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.pidstatus = "success";
            state.pidmessage = "StopSale Successfully Deleted";
        },
        deleteStopSaleImageFail: (state, { payload }) => {
            state.pisLoading = false;
            state.pidstatus = "fail";
            state.pidmessage = payload;
        },

        reset: (state) => {

            state.piscLoading = false;
            state.pcstatus = "false";
            state.pcMessage = "";
            state.productId = "";
        },
        imageUploadSuccess: (state, { payload }) => {
            state.piscLoading = false;
            state.pcstatus = "success";
            state.pcMessage = payload.message;

        },
        imageUploadFailure: (state, { payload }) => {
            state.piscLoading = false;
            state.pcstatus = "fail";
            state.pcMessage = payload.message;

        },
    },
});

const { reducer, actions } = productSlice;

export const { getStopSalePending, getStopSaleSuccess, getStopSaleImagePending, getStopSaleImageFail, getStopSaleImageSuccess, getStopSaleFail, getSStopSalePending, getSStopSaleSuccess, getSStopSaleFail,
    createStopSalePending, createStopSaleSuccess, createStopSaleFail,
    modifyStopSalePending, modifyStopSaleSuccess, modifyStopSaleFail,
    deleteStopSalePending, deleteStopSaleSuccess, deleteStopSaleFail, reset, imageUploadSuccess, imageUploadFailure, getSStopSaleImagePending, getSStopSaleImageSuccess, getSStopSaleImageFail, modifyStopSaleImagePending, modifyStopSaleImageSuccess, modifyStopSaleImageFail, deleteStopSaleImageFail, deleteStopSaleImageSuccess, deleteStopSaleImagePending } = actions;

export default reducer;
